$(function () {
    'use strict';

    //Suppression d'un fichier
    var btnDeleteFile = $('a.delete_file');
    //Page dossier>candidature > depot de audio/video/lm
    var tenantUpload = $('.tenant-upload');
    if (tenantUpload.length > 0) {
        tenantUpload.on('change', changeTenantUpload);
    }

    btnDeleteFile.on('click', deleteFile);

    function changeTenantUpload(e) {
        var elem = e.currentTarget;
        var $img = $(elem).parent().find('img');
        var $iconElem = $(elem).parent().find('.icon');
        var icon = $iconElem.data('icon');
        if (elem.files.length > 0) {
            $iconElem.removeClass('d-none').removeClass(icon).addClass('icon-tick');
            $img.addClass('d-none');
            $(elem).parent().parent().css('background-color', '#609f7e');
        } else {
            $img.addClass('d-none');
            $iconElem.removeClass('icon-tick').removeClass('d-none').addClass(icon);
            $(elem).parent().parent().css('background-color', '#f5f5f5');
        }
    }

    function deleteFile(e) {
        var theBtn = $(e.currentTarget);
        var idCand = theBtn.data('id');
        var type = theBtn.data('type');
        if (confirm('Supprimer le fichier ' + type + '?')) {
            $.ajax({
                url: 'locataire/mon_dossier/deleteFileCandidature/' + idCand + '/' + type,
                method: 'DELETE',
            }).done(function(data) {
                window.location.reload();
            });
        }
    }

});
